import { getSizeForBreakpoint } from './getSizeForBreakpoint';
export const getSizesMap = (breakpoints, sizes) => breakpoints
    .map((breakpoint, i) => {
    const size = getSizeForBreakpoint(sizes, i);
    let width;
    if (size > 2) {
        // Size is absolute value in px
        width = size + 'px';
    }
    else {
        // Size is already a fraction (or unset). Convert it to vw (percentage
        // of viewport width)
        width = Math.round(100 * (size || 1)) + 'vw';
    }
    // Include a media query for all but the last size
    if (i + 1 < breakpoints.length) {
        return `(max-width: ${breakpoint}) ${width}`;
    }
    return width;
})
    .join(', ');
//# sourceMappingURL=getSizesMap.js.map